import type { FC } from 'react'

import CalendarIcon from '@/assets/icons/icon-calendar.svg'
import CloseIcon from '@/assets/icons/icon-close.svg'
import { classNames } from '@/utils/helpers'

import { TimeDifference } from '../components/TimeDifference'

interface Props {
  scheduledDate: Date
  onClearScheduledMessage: (date: Date | undefined) => void
}

export const ChatScheduleMessageIndicator: FC<Props> = ({
  scheduledDate,
  onClearScheduledMessage,
}) => {
  return (
    <div className="absolute bottom-full left-0 pb-4">
      <div
        className={classNames(
          'rounded-md  border p-2.5',
          'border-primary-100 bg-white',
          'border-primary-500 dark:bg-secondary-700',
        )}
      >
        <div className="flex items-center gap-2">
          <CalendarIcon className="h-4 w-4 text-primary-500 dark:text-primary-500" />
          <span className="text-sm font-medium text-secondary-300">
            Scheduled for{' '}
            <span className="font-medium text-secondary-500 dark:text-white">
              <TimeDifference date={scheduledDate.toString()} />
            </span>
          </span>
          <CloseIcon
            className="cursor-pointer text-secondary-100"
            onClick={() => onClearScheduledMessage(undefined)}
          />
        </div>
      </div>
    </div>
  )
}
